import { Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { authGuard } from './auth.guard';

export const routes: Routes = [
  //login
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((c) => c.LoginComponent),
  },

  //Dashboard
  {
    path: '',
    loadComponent: () =>
      import('./components/approvallist/approvallist.component').then(
        (mod) => mod.ApprovallistComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'approvallist',
    loadComponent: () =>
      import('./components/approvallist/approvallist.component').then(
        (mod) => mod.ApprovallistComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'approvallist/:id',
    loadComponent: () =>
      import(
        './components/approvallist/approvallist-details/approvallist-details.component'
      ).then((mod) => mod.ApprovallistDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'suppliers',
    loadComponent: () =>
      import('./components/suppliers/suppliers.component').then(
        (mod) => mod.SuppliersComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'suppliers/:id',
    loadComponent: () =>
      import(
        './components/suppliers/supplier-details/supplier-details.component'
      ).then((mod) => mod.SupplierDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'newapplications',
    loadChildren: () =>
      import('./components/new-applications/new-applications.routes').then(
        (child) => child.new_application_routes
      ),
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    loadComponent: () => import('./components/admin/admin.component').then((mod) => mod.AdminComponent),
    canActivate: [authGuard]
  },
  {
    path: '*',
    loadComponent: () =>
      import('./components/approvallist/approvallist.component').then(
        (mod) => mod.ApprovallistComponent
      ),
    canActivate: [authGuard],
  },
];
